import React from "react";
import Hero from "../components/Hero";
import Process from "../components/Process";
import Marquee from "../components/Marquee";
import Reveal from "../components/Reveal";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function Home() {
  return (
    <div data-testid="page-home">
      <Hero />
      <Marquee
        words={["ITView", "Servicii IT", "24/7 Support", "On-site & Remote", "Est. 2014", "itview.ro"]}
        speed={70}
      />
      <Process />

      {/* CTA section */}
      <section className="py-24 lg:py-36 border-t border-line bg-sandwarm">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <Reveal className="lg:col-span-8">
            <span className="overline text-clay">HAI SĂ ÎNCEPEM</span>
            <h2 className="mt-4 font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-[-0.035em] max-w-3xl">
              IT-ul tău funcționează sau te ține pe loc?
            </h2>
            <p className="mt-6 max-w-xl text-inksoft leading-relaxed">
              Programează o evaluare gratuită. Ne uităm peste ce ai, îți spunem
              exact ce ai de îmbunătățit și cât te costă — fără să te obligi la
              nimic.
            </p>
          </Reveal>
          <Reveal className="lg:col-span-4 flex lg:justify-end" delay={0.15}>
            <Link
              to="/contact"
              data-testid="home-cta-contact"
              className="group inline-flex items-center gap-3 px-7 py-5 rounded-full bg-ink text-sand font-semibold text-sm hover:bg-clay hover:text-white transition-colors"
            >
              Trimite o cerere
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
